import validator from "validator";
import isEmpty from "lodash/isEmpty";
import {
  EVISA_INQ_TYPE,
  FLIGHT_HOTEL_INQ_TYPE,
  FLIGHT_INQ_TYPE,
  spaceRegex,
} from "../../constants/common";
import { map } from "lodash";

export function ValidateFlightSearch(data) {
  console.log("data---->", data);
  let errors = {};

  if (data.full_name !== undefined && validator.isEmpty(data.full_name)) {
    errors.full_name = "Full name  is required";
  }

  if (data.email !== undefined && validator.isEmpty(data.email)) {
    errors.email = "Email  is required";
  }

  if (data.phone !== undefined && validator.isEmpty(data.phone)) {
    errors.phone = "Phone no required";
  }

  if (
    data.mainType === EVISA_INQ_TYPE &&
    data.passports &&
    data.passports.length === 0 &&
    validator.isEmpty(data.other_passport_type)
  ) {
    let errorValues = [];
    data.passports.map((d) => {
      errorValues = [...errorValues, d.passport_front_page, d.avatar_photo];
      return null;
    });
    if (errorValues.every((d) => d === null)) {
      errors.passports = "Please upload documents";
    }
  }

  if (
    data.mainType === EVISA_INQ_TYPE &&
    data.other_passports &&
    data.other_passports.length === 0 &&
    validator.isEmpty(data.passport_type)
  ) {
    let errorValues = [];
    data.other_passports.map((d) => {
      errorValues = [
        ...errorValues,
        d.passport_front_page,
        d.avatar_photo,
        d.green_card,
      ];
      return null;
    });
    if (errorValues.every((d) => d === null)) {
      errors.other_passports = "Please upload documents";
    }
  }

  if (
    !data.isDateFixed &&
    !data.isDateFlexible &&
    data.mainType !== EVISA_INQ_TYPE
  ) {
    errors.date_fix_flexi =
      "Please select one of the dates preferences from above (Flexible or Fixed)";
  }
  if (!data.isTermsAccepted) {
    errors.isTermsAccepted = "Please accept terms & conditions";
  }
  // if (data.phone !== undefined && validator.isEmpty(data.phone) === false) {
  //   if (!validator.isLength(data.phone, { min: 11, max: 11 })) {
  //     errors.phone = "Phone no should be of 10 digit";
  //   }
  // }

  if (data.phone !== undefined && validator.isEmpty(data.phone) === false) {
    if (!validator.isNumeric(data.phone)) {
      errors.phone = "Enter enter valid phone number";
    }
  }

  if (
    data.full_name !== undefined &&
    !validator.isEmpty(data.full_name) &&
    spaceRegex.test(data.full_name) === false
  ) {
    errors.fname = "Full name  is invalid";
  }

  if (data.email !== undefined && validator.isEmpty(data.email)) {
    errors.email = "Email is required";
  }

  if (data.email !== undefined && validator.isEmpty(data.email) === false) {
    if (!validator.isEmail(data.email)) {
      errors.email = "Email is invalid";
    }
  }
  if (
    data.mainType === FLIGHT_HOTEL_INQ_TYPE ||
    data.mainType === FLIGHT_INQ_TYPE
  ) {
    if (!data.sourceStation) {
      errors.sourceStation = "Please select departure station";
    }

    if (!data.destination) {
      errors.destination = "Please select arrival station";
    }
  }

  // validations only triggered  when type = fligh+Hotel
  if (data.mainType === FLIGHT_HOTEL_INQ_TYPE) {
    if (
      data.no_of_rooms !== undefined &&
      validator.isEmpty(data.no_of_rooms.toString())
    ) {
      errors.no_of_rooms = "Please select no of rooms";
    }

    let noOfRooms = map(data.no_of_rooms, "noOfRoom");
    let isZero = noOfRooms.every((s) => s === 0);

    console.log("isZero", isZero);
    if (isZero) {
      errors.no_of_rooms = "Please select no of rooms";
    }
    if (
      data.room_ratings !== undefined &&
      validator.isEmpty(data.room_ratings)
    ) {
      errors.room_ratings = "Please select ratings of rooms";
    }
  }

  // validations only triggered  when type = eVisa
  if (data.mainType === EVISA_INQ_TYPE) {
    // if (data.no_of_evisa !== undefined && validator.isEmpty(data.no_of_evisa)) {
    //   errors.no_of_evisa = "Please select no of e-visa";
    // }
    // if (data.nationalities.length === 0) {
    //   errors.nationalities = "Please select nationalities";
    // }
    if (validator.isEmpty(data.other_passport_type)) {
      if (
        data.passport_type !== undefined &&
        validator.isEmpty(data.passport_type)
      ) {
        errors.passport_type = "Please select no of US/Canada Passports";
      }
    }
    if (validator.isEmpty(data.passport_type)) {
      if (
        data.other_passport_type !== undefined &&
        validator.isEmpty(data.other_passport_type)
      ) {
        errors.other_passport_type =
          "Please select no of Other Nationality Passports";
      }
    }

    // if (
    //   data.no_of_passports !== undefined &&
    //   validator.isEmpty(data.no_of_passports)
    // ) {
    //   errors.no_of_passports = "Please select no of passports";
    // }
  }

  console.log("data", data);
  console.log("errors", errors);

  return { errors, isValid: isEmpty(errors) };
}

export function ValidateFileUploads(uploadsArray) {
  console.log("in", uploadsArray);
  let errors = [];
  uploadsArray.map((d) => {
    errors = [
      ...errors,
      {
        passport_front_page: null,
        avatar_photo: null,
        green_card: null,
      },
    ];
    return null;
  });

  uploadsArray.map((data, i) => {
    if (!data.passport_front_page) {
      errors[i].passport_front_page = "Please upload passport front page";
    }
    if (!data.avatar_photo) {
      errors[i].avatar_photo = "Please upload photo";
    }
    if (!data.green_card) {
      errors[i].green_card = "Please upload green card ";
    }
    return null;
  });
  console.log("errors", errors);

  return errors;
}

export function ValidateUSCanadaFileUploads(uploadsArray) {
  console.log("in", uploadsArray);
  let errors = [];
  uploadsArray.map((d) => {
    errors = [
      ...errors,
      {
        passport_front_page: null,
        avatar_photo: null,
      },
    ];
    return null;
  });
  console.log("errors", errors);

  uploadsArray.map((data, i) => {
    if (!data.passport_front_page) {
      errors[i].passport_front_page = "Please upload passport front page";
    }
    if (!data.avatar_photo) {
      errors[i].avatar_photo = "Please upload photo";
    }

    return null;
  });

  return errors;
}

export function ValidateHajjForm(data) {
  console.log("data", data);
  let errors = {};

  if (data.full_name !== undefined && validator.isEmpty(data.full_name)) {
    errors.full_name = "Full name  is required";
  }

  if (data.email !== undefined && validator.isEmpty(data.email)) {
    errors.email = "Email  is required";
  }

  if (data.phone !== undefined && validator.isEmpty(data.phone)) {
    errors.phone = "Phone no required";
  }
  if (data.phone === "+1") {
    errors.phone = "Phone no required";
  }

  if (data.phone !== undefined && validator.isEmpty(data.phone) === false) {
    if (!validator.isNumeric(data.phone)) {
      errors.phone = "Enter enter valid phone number";
    }
    // var pattern = /^(?!0+$)\d{8,}$/;
    // if (pattern.test()) {
    //   errors.phone = "Enter enter valid phone number";
    // }
    // if (data?.phone === '1')) {
    //   errors.phone = "Enter enter valid phone number";
    // }
  }
  if (!data.isTermsAccepted) {
    errors.isTermsAccepted = "Please accept terms & conditions";
  }
  if (data.phone !== undefined && validator.isEmpty(data.phone) === false) {
    if (!validator.isNumeric(data.phone)) {
      errors.phone = "Enter enter valid phone number";
    }
    // var pattern = /^(?!0+$)\d{8,}$/;
    // if (pattern.test(data.phone)) {
    //   errors.phone = "Enter enter valid phone number";
    // }
    // if (data?.phone === '1')) {
    //   errors.phone = "Enter enter valid phone number";
    // }
  }

  if (
    data.full_name !== undefined &&
    !validator.isEmpty(data.full_name) &&
    spaceRegex.test(data.full_name) === false
  ) {
    errors.fname = "Full name  is invalid";
  }

  if (data.email !== undefined && validator.isEmpty(data.email)) {
    errors.email = "Email is required";
  }
  // if (!data.isAmericalPassportHolder) {
  //   errors.isAmericalPassportHolder = "Please select  this";
  // }

  if (data.email !== undefined && validator.isEmpty(data.email) === false) {
    if (!validator.isEmail(data.email)) {
      errors.email = "Email is invalid";
    }
  }

  if (
    data.no_of_travellers !== undefined &&
    validator.isEmpty(data.no_of_travellers)
  ) {
    errors.no_of_travellers = "Please enter a number of travelers";
  }
  if (
    data.no_of_travellers !== undefined &&
    validator.isEmpty(data.no_of_travellers) === false
  ) {
    if (!validator.isNumeric(data.no_of_travellers)) {
      errors.no_of_travellers =
        "Enter enter valid value for number of travelers";
    }
  }
  if (data.mainType === "umrahInquiry") {
    if (
      data.isUmrahOnly === null &&
      data.isUmrahDubaiPackage === null &&
      data.isUmrahTurkeyPackage === null
    ) {
      errors.otherPackages = "Please select any from above";
    }
  }

  console.log("data", data);
  console.log("errors", errors);

  return { errors, isValid: isEmpty(errors) };
}
